export default __webpack_public_path__ + "static/media/twitter_header_1500x500px.017847e3.png";